import React from 'react';

import StackingLayout from 'common/components/core/StackingLayout/StackingLayout';

import './ItemOwner.scss';

export type ItemOwnerProps = {
  account?: OwnerEntityDescriptor;
  organization?: OwnerEntityDescriptor;
  customer?: OwnerEntityDescriptor;
};

export type OwnerEntityDescriptor = {
  id: string;
  name: string;
};

export default function ItemOwner({ account, organization, customer }: ItemOwnerProps) {
  const ownerText = account?.name ?? organization?.name ?? customer?.name;

  if (!ownerText) return null;

  return (
    <StackingLayout className="item-owner">
      <span className="item-owner__name">{ownerText}</span>
    </StackingLayout>
  );
}
